export const REPLACE_GAMES = 'REPLACE_GAMES';
export const REPLACE_GAMES_SCORE = 'REPLACE_GAMES_SCORE';
export const SET_IGNORE_PLAYS = 'SET_IGNORE_PLAYS';
